module.exports = {
  "container": {
    "width": "750"
  },
  "operate-box": {
    "backgroundColor": "#FFFFFF",
    "width": "558",
    "position": "fixed",
    "left": "96",
    "zIndex": 100,
    "top": "400"
  },
  "operate-box-item": {
    "paddingTop": "36",
    "paddingRight": "36",
    "paddingBottom": "36",
    "paddingLeft": "36",
    "textAlign": "center"
  },
  "operate-box-item-text": {
    "color": "#1E2E37",
    "fontSize": "36"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-563d30e4!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-operation-modal/index.vue
// module id = 482
// module chunks = 0 1